/**
 * Cálculos relacionados a ejercicios de cardio/resistencia.
 */

/**
 * Calcula el ritmo (pace) en min/km dado distancia (m) y tiempo (min).
 * Devuelve null si no se puede calcular (datos faltantes o cero).
 */
export function calcPaceMinPerKm(distanceM, durationMin) {
  const d = Number(distanceM);
  const t = Number(durationMin);
  if (!d || !t || d <= 0 || t <= 0) return null;
  return t / (d / 1000); // minutos por kilómetro
}

/**
 * Formatea pace como MM:SS string (ej: 7:30) o null si no aplica.
 */
export function formatPace(paceMinPerKm) {
  if (paceMinPerKm == null || !isFinite(paceMinPerKm)) return null;
  const minutes = Math.floor(paceMinPerKm);
  const seconds = Math.round((paceMinPerKm - minutes) * 60);
  // Edge: 7.999 → 8:00 (no 7:60)
  if (seconds === 60) return `${minutes + 1}:00`;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

/**
 * Atajo: devuelve "7:30 min/km" o null.
 */
export function paceLabel(distanceM, durationMin) {
  const p = calcPaceMinPerKm(distanceM, durationMin);
  const f = formatPace(p);
  return f ? `${f} min/km` : null;
}
